import type {ReactAction} from '@netx/core/bootstrap';
import {faEye} from '@fortawesome/pro-solid-svg-icons';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {cartActionManageVisibilityHide} from './cart-manage-visibility-hide';
import {cartActionManageVisibilityShow} from './cart-manage-visibility-show';

/**
 * Manage cart asset visibility
 * @param params
 * @returns Action
 */
export const cartActionManageVisibility = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-visibility',
	cb: () => {},
	icon: faEye,
	get label() {
		return CART_CURRENT_ACTION_LABELS.VISIBILITY;
	},
	children: [
		cartActionManageVisibilityShow(),
		cartActionManageVisibilityHide(),
	],
	...params,
});

export default cartActionManageVisibility;
